//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('batchDeliveries', {
//        templateUrl: 'views/components/views/batchDeliveries/batchDeliveries.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'batchDeliveriesService', function ($stateParams, batchDeliveriesService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                setting: {},
//                itemsListRelatedTo: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await batchDeliveriesService.getBatchDelivery({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            async function loadBatchDeliveryRelatedTo() {
//                vm.model.itemsListRelatedTo = await batchDeliveriesService.listBatchDeliveryRelatedTo({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadBatchDeliveryRelatedTo();
//            }
//		}]
//	});
//})();
